import { Extension } from '@tiptap/core';

export interface BackgroundColorOptions {
   types: string[];
   colors: string[];
   defaultColor: null | string;
}

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      backgroundColor: {
         setBackgroundColor: (color: string) => ReturnType;
         unSetBackgroundColor: () => ReturnType;
      };
   }
}

export const CustomBackgroundColor = Extension.create<BackgroundColorOptions>({
   name: 'backgroundColor',
   addOptions() {
      return {
         types: ['tableCell', 'tableHeader'],
         colors: [
            '#FFFFFF',
            '#CCCCCC',
            '#9E9E9E',
            '#858585',
            '#000000',
            '#DD4A36',
            '#F4A967',
            '#FFD466',
            '#89BC77',
            '#6293E4',
            '#F9A0F0',
         ],
         defaultColor: null,
      };
   },
   addGlobalAttributes() {
      return [
         {
            types: this.options.types,
            attributes: {
               backgroundColor: {
                  default: this.options.defaultColor,
                  parseHTML: element => element.style.backgroundColor || this.options.defaultColor,
                  renderHTML: attributes => {
                     if (attributes.backgroundColor === this.options.defaultColor) {
                        return {};
                     }

                     return { style: `background-color: ${attributes.backgroundColor}` };
                  },
               },
            },
         },
      ];
   },
   addStorage() {
      return {
         colors: this.options.colors,
         currentColor: null,
      };
   },
   onSelectionUpdate() {
      this.storage.currentColor =
         this.editor.getAttributes('tableHeader').backgroundColor ||
         this.editor.getAttributes('tableCell').backgroundColor;
   },
   addCommands() {
      return {
         setBackgroundColor:
            (color: string) =>
            ({ commands }) => {
               if (!this.options.colors.includes(color)) {
                  return false;
               }
               this.storage.currentColor = color;
               return this.options.types.every(type =>
                  commands.updateAttributes(type, { backgroundColor: color })
               );
            },
         unSetBackgroundColor:
            () =>
            ({ commands }) => {
               this.storage.currentColor = null;
               return this.options.types.every(type =>
                  commands.resetAttributes(type, 'backgroundColor')
               );
            },
      };
   },
});
